import { Modifier } from './Modifier';
export class RadialWrinkleModifier extends Modifier {
    constructor(disabled, parameters, noise3D) {
        super('radial_wrinkle', disabled, parameters, false);
        this.noise3D = noise3D;
    }
    apply(geometry) {
        if (this.disabled)
            return;
        const positions = geometry.attributes.position.array;
        const { perimeter = 50, strength = 1.0, variation = 0.5 } = this.parameters;
        // Clamp strength to a maximum of 0.015
        const clampedStrength = Math.min(strength, 0.015);
        // Allow perimeter = 0, but not less than 0
        if (perimeter < 0) {
            console.warn('[RadialWrinkleModifier] perimeter < 0 is not allowed. Skipping modifier.');
            return;
        }
        // If strength is 0, don't modify the geometry at all
        if (clampedStrength <= 0)
            return;
        // Get the height of the geometry for normalization
        let minY = Infinity;
        let maxY = -Infinity;
        for (let i = 0; i < positions.length; i += 3) {
            const y = positions[i + 1];
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        const height = maxY - minY;
        for (let i = 0; i < positions.length; i += 3) {
            const x = positions[i];
            const y = positions[i + 1];
            const z = positions[i + 2];
            // Calculate current radius and angle
            const radius = Math.sqrt(x * x + z * z);
            // Skip if radius is too small to avoid division by zero
            if (radius < 0.0001) {
                console.warn('[RadialWrinkleModifier] radius is too small. Skipping modifier.');
                continue;
            }
            const angle = Math.atan2(z, x);
            // Calculate normalized height (0 to 1)
            const normalizedHeight = (y - minY) / height;
            // Calculate normalized angle in [0, 1] for seamless noise
            const normalizedAngle = ((angle % (2 * Math.PI)) + (2 * Math.PI)) % (2 * Math.PI) / (2 * Math.PI);
            // Map angle to a circle in 2D for periodic noise
            const period = perimeter; // Use perimeter as the period/scale
            const circleX = Math.cos(normalizedAngle * 2 * Math.PI) * period;
            const circleY = Math.sin(normalizedAngle * 2 * Math.PI) * period;
            // Generate noise value for variation using periodic mapping
            const noise = this.noise3D(circleX, circleY, normalizedHeight * 10);
            const baseDisplacement = radius * 5.0; // Base displacement is 500% of radius
            const displacement = baseDisplacement * clampedStrength * (noise * 2 - 1);
            // Only apply if displacement is valid
            if (!isNaN(displacement) && isFinite(displacement)) {
                positions[i] += (circleX / radius) * displacement;
                positions[i + 2] += (circleY / radius) * displacement;
            }
            else {
                console.warn('[RadialWrinkleModifier] displacement is NaN or infinite. Skipping modifier.');
            }
        }
        geometry.attributes.position.needsUpdate = true;
        geometry.computeVertexNormals();
    }
}
